import { render, staticRenderFns } from "./indexAgent.vue?vue&type=template&id=58e51be6"
import script from "./indexAgent.vue?vue&type=script&lang=js"
export * from "./indexAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports